module.exports = __webpack_public_path__ + "assets/img/Spark-Systems-Website-w720.3490408d.webp";